/**
 * @generated SignedSource<<4e7a85e9280773031be8b92976e3d34f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiCreditsPolicyDialogCreditsQuery$variables = Record<PropertyKey, never>;
export type aiCreditsPolicyDialogCreditsQuery$data = {
  readonly aiCredits: {
    readonly availableFreeCredits: number;
  } | null;
};
export type aiCreditsPolicyDialogCreditsQuery = {
  response: aiCreditsPolicyDialogCreditsQuery$data;
  variables: aiCreditsPolicyDialogCreditsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AICreditsSummary",
    "kind": "LinkedField",
    "name": "aiCredits",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availableFreeCredits",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiCreditsPolicyDialogCreditsQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "aiCreditsPolicyDialogCreditsQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "ffcb160bed29a6858a0acfeb140909b6",
    "id": null,
    "metadata": {},
    "name": "aiCreditsPolicyDialogCreditsQuery",
    "operationKind": "query",
    "text": "query aiCreditsPolicyDialogCreditsQuery {\n  aiCredits {\n    availableFreeCredits\n  }\n}\n"
  }
};
})();

(node as any).hash = "e871a2f1c99eed87108364875037d2e0";

export default node;
